import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import getDay from 'date-fns/getDay';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import { Container, Row, Col, Accordion, Button } from 'react-bootstrap';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import Separator from '../separator/Separator'; // Constants

import * as CONSTANTS from '../../constants';
import Heading from '../heading/Heading';
import PreferredLocationForm from './Preferred';
import { FaRegClock } from 'react-icons/fa';

var LocationCard = /*#__PURE__*/function (_Component) {
  _inherits(LocationCard, _Component);

  var _super = _createSuper(LocationCard);

  function LocationCard(props) {
    var _schedule, _schedule$_this$today;

    var _this;

    _classCallCheck(this, LocationCard);

    _this = _super.call(this, props);

    _this.Hours = function () {
      return /*#__PURE__*/React.createElement("ul", null, Object.keys(_this.props.location.hours).map(function (property, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: "hours-".concat(index)
        }, property, ": ", _this.props.location.hours[property].full);
      }));
    };

    var schedule = [{
      "open": props.data.sundayOpen,
      "close": props.data.sundayClose
    }, {
      "open": props.data.mondayOpen,
      "close": props.data.mondayClose
    }, {
      "open": props.data.tuesdayOpen,
      "close": props.data.tuesdayClose
    }, {
      "open": props.data.wednesdayOpen,
      "close": props.data.wednesdayClose
    }, {
      "open": props.data.thursdayOpen,
      "close": props.data.thursdayClose
    }, {
      "open": props.data.fridayOpen,
      "close": props.data.fridayClose
    }, {
      "open": props.data.saturdayOpen,
      "close": props.data.saturdayClose
    }]; //MOBILE NOTE - maps: before link will open in app

    _this.directionsURL = "https://maps.google.com/maps?q=Cracker+Barrel,+" + props.data.address1 + "+" + props.data.city + ",+" + props.data.state + "+" + props.data.zip;
    _this.directionsURL = _this.directionsURL.replace(/\s/g, "+");
    _this.state = {
      serviceOpen: false,
      hoursOpen: false,
      orderOpen: false
    }; // TODO: Review how services available is passed from Brandify

    _this.defaultServices = []; // [...this.props.location.services].splice(0, 3);

    _this.additionalServices = []; // [...this.props.location.services].splice(3, this.props.location.services.length);

    _this.today = getDay(new Date());
    _this.weekDay = CONSTANTS.DAYS[_this.today]; // this.tomorrow = CONSTANTS.DAYS[this.today + 1];

    _this.tomorrow = (_schedule = schedule[_this.today + 1]) === null || _schedule === void 0 ? void 0 : _schedule.open; // this.closeHours = props.location?.hours[this.weekDay]?.close || "9:00 PM";

    _this.closeHours = (_schedule$_this$today = schedule[_this.today]) === null || _schedule$_this$today === void 0 ? void 0 : _schedule$_this$today.close; // props.location?.hours[this.weekDay]?.close;

    _this.openHour = _this.isOpen();
    return _this;
  }

  _createClass(LocationCard, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.preferredLocation !== this.props.preferredLocation) {
        this.setState({
          preferredLocation: newProps.preferredLocation
        });
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      if (this.closeHours !== '') {
        var hours;
        var minutes;
        var minute;
        var meridian;

        try {
          var _this$closeHours$spli = this.closeHours.split(':');

          var _this$closeHours$spli2 = _slicedToArray(_this$closeHours$spli, 2);

          hours = _this$closeHours$spli2[0];
          minutes = _this$closeHours$spli2[1];

          var _minutes$split = minutes.split(' ');

          var _minutes$split2 = _slicedToArray(_minutes$split, 2);

          minute = _minutes$split2[0];
          meridian = _minutes$split2[1];
        } catch (_unused) {}

        hours = meridian === 'PM' ? parseInt(hours) + 12 : hours;
        var closing = new Date();
        closing.setHours(hours);
        closing.setMinutes(minute);
        closing.setSeconds(0);
        var open = differenceInMilliseconds(closing, new Date());
        var result = "Open until ".concat(this.closeHours);

        if (open <= 0) {
          result = "Closed - Opens tomorrow at ".concat(this.tomorrow);
        }

        return result;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isFinder = _this$props.isFinder,
          showHeader = _this$props.showHeader,
          data = _this$props.data,
          isCnbSite = _this$props.isCnbSite,
          discoverableGhostKitchen = _this$props.discoverableGhostKitchen;
      var distanceTo = Math.round(this.props.data.milesFromSource * 100) / 100;

      if (isCnbSite || discoverableGhostKitchen) {
        return /*#__PURE__*/React.createElement("div", {
          className: "cb-location-card"
        }, showHeader && !discoverableGhostKitchen && /*#__PURE__*/React.createElement("div", {
          href: data.detailLink
        }, /*#__PURE__*/React.createElement("div", {
          className: "cb-location-finder__finder-card-header"
        }, /*#__PURE__*/React.createElement("h2", null, this.props.data.alternateName || this.props.data.city), !isNaN(distanceTo) && /*#__PURE__*/React.createElement("p", {
          className: "cb-location-finder__finder-miles"
        }, distanceTo, " mi"))), showHeader && discoverableGhostKitchen && /*#__PURE__*/React.createElement("div", {
          className: "cb-location-finder__finder-card-header"
        }, /*#__PURE__*/React.createElement("h2", null, this.props.data.alternateName || this.props.data.city), !isNaN(distanceTo) && /*#__PURE__*/React.createElement("p", {
          className: "cb-location-finder__finder-miles"
        }, distanceTo, " mi")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
          className: "cb-location-finder__finder-card-header"
        }, /*#__PURE__*/React.createElement("p", {
          className: "cb-type-title-2"
        }, this.props.data.address1))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
          className: "cb-type-title-2"
        }, this.props.data.city, ", ", this.props.data.state, " ", Boolean(this.props.data.zip) ? this.props.data.zip.slice(0, 5) : ""))))));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "cb-location-card"
      }, showHeader && /*#__PURE__*/React.createElement("a", {
        href: data.detailLink
      }, /*#__PURE__*/React.createElement("div", {
        className: "cb-location-finder__finder-card-header"
      }, /*#__PURE__*/React.createElement("h2", null, this.props.data.alternateName || this.props.data.city), !isNaN(distanceTo) && /*#__PURE__*/React.createElement("p", {
        className: "cb-location-finder__finder-miles"
      }, distanceTo, " mi"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, {
        className: "mt-8"
      }, Boolean(this.closeHours && this.tomorrow && !this.props.data.temporarilyClosed) && /*#__PURE__*/React.createElement(Col, {
        style: {
          paddingRight: '0'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: "cb-type-title-2 cb-color-orange-400"
      }, this.isOpen(), " ", /*#__PURE__*/React.createElement(FaRegClock, {
        className: "org-clock"
      }))), this.props.data.temporarilyClosed && /*#__PURE__*/React.createElement(Col, {
        style: {
          paddingRight: '0'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: "cb-type-title-2 cb-color-orange-400"
      }, "This store is temporarily closed."))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        className: "cb-location-finder__finder-card-header"
      }, /*#__PURE__*/React.createElement("p", {
        className: "cb-type-title-2"
      }, this.props.data.address1), /*#__PURE__*/React.createElement("a", {
        className: "cb-location-finder__finder-miles",
        href: "tel:".concat(this.props.data.phone),
        style: {
          textDecoration: "none"
        }
      }, /*#__PURE__*/React.createElement("p", {
        className: "cb-type-title-2 cb-color-brown-400"
      }, this.props.data.phone)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
        className: "cb-type-title-2"
      }, this.props.data.city, ", ", this.props.data.state, " ", Boolean(this.props.data.zip) ? this.props.data.zip.slice(0, 5) : ""))), !(data === null || data === void 0 ? void 0 : data.discoverableGhostKitchen) && /*#__PURE__*/React.createElement(Row, {
        className: "mt-8"
      }, /*#__PURE__*/React.createElement(Col, {
        className: "cb-location-finder__finder-card-header"
      }, /*#__PURE__*/React.createElement("a", {
        href: this.directionsURL,
        className: "cb-type-subheading-2 cb-color-red-400"
      }, "Directions"), isFinder && /*#__PURE__*/React.createElement("a", {
        href: data.detailLink,
        className: "cb-type-subheading-2 cb-color-red-400"
      }, "View Detail"))))));
    }
  }]);

  return LocationCard;
}(Component);

export default LocationCard;